<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div class="dialog-content">
    <div class="header">
        <div class="dialog-title" matDialogTitle>
            <h4>{{ 'eula.title.accept' | translate }}</h4>
        </div>
    </div>
    <div [config]="preloaderService.getLoadingConfig(loaderKey)" [suiIsLoading]="loaderKey" class="content preloader-wrapper">
        @if (eula$ | async; as eula) {
            <p>
                {{ 'eula.info.accept' | translate }}
                <a [href]="downloadUrl" class="btn btn-link p-0 align-baseline">{{ 'eula.info.agreement' | translate }}</a>
            </p>
            <p class="eula-date">{{ 'eula.info.effectiveDate' | translate }}&nbsp;{{ eula.versionDate | date: 'MMM d, y, h:mm:ss a' }}</p>
        }
    </div>
    <div class="footer">
        <div class="footer-actions">
            <button (click)="close()" matDialogClose windeTransparent>
                <sui-svg-icon icon="cross"/>
                {{ 'entity.action.cancel' | translate }}
            </button>
            <button (click)="accept()" windeGreen>
                <sui-svg-icon icon="save"/>
                {{ 'entity.action.accept' | translate }}
            </button>
        </div>
    </div>
</div>
